$(document).ready(function () {
    $('.projekt-akkordeon-header').click(function () {
        $(this).toggleClass('open');
        $(this).next('.projekt-akkordeon-content').toggleClass('open');
    });
    $('.bttn__open-extended-content').click(function () {
        $(this).hide();
        $(this).next('.extended-content').show();
    });


    $('.bttn__spendenwidget').click(function () {
        $('#iframe__spendenwidget').attr('src', $(this).data('url'));
    });

    if ($('.projekt-akkordeon-header').length > 0 && $(window).width() > 768) {
        $('.projekt-akkordeon-header').first().trigger('click');
    }

    if (window.location.hash.includes('#projekt-')) {
        if ($('.projekt-akkordeon-header').length > 0 && $(window).width() > 768) {
            $('.projekt-akkordeon-header').first().trigger('click');
        }
        $(window.location.hash).find('.projekt-akkordeon-header').trigger('click');
    }
});